'use client';
import React from 'react';
import CenterModalContents from './CenterModalContents.mjs';
import CenterModalWrapper from './CenterModalWrapper.mjs';
import { CENTER_MODAL_TYPE } from '../../../constants/modal.mjs';
import useApplyLogging from '../../../hooks/useApplyLogging.mjs';
import useCenterModalContentScrollable from '../../../hooks/useCenterModalContentScrollable.mjs';
import usePortal from '../../../hooks/usePortal.mjs';

/**
 * CenterModalNotice
 *
 * ```jsx
 * const {isShow, open, close} = useCenterModal();
 *
 * const openCenterModalNotice = open({
 *     type: CENTER_MODAL_TYPE.NOTICE,
 *     content: { title, description, subText, children },
 *     button: { text, variant, onClick },
 *     onClickDimmedLayer: (event) => { console.info(event); close(); },
 * });
 * ```
 *
 * ### Provider 설정
 * `DefignProvider`를 컴포넌트 최상단에 선언해야 CenterModalNotice를 사용할 수 있습니다.
 *
 * ```jsx
 * <DefignProvider>
 *     {children}
 * </DefignProvider>
 * ```
 */
function CenterModalNotice(_ref) {
  let {
    content,
    button,
    onClickDimmedLayer
  } = _ref;
  useApplyLogging('CenterModalNotice');
  const {
    scrollable,
    $modal
  } = useCenterModalContentScrollable();
  const Portal = usePortal();
  return /*#__PURE__*/React.createElement(Portal, null, /*#__PURE__*/React.createElement(CenterModalWrapper, {
    type: CENTER_MODAL_TYPE.NOTICE,
    button: button,
    ref: $modal,
    onClickDimmedLayer: onClickDimmedLayer
  }, /*#__PURE__*/React.createElement(CenterModalContents, {
    ...content,
    scrollable: scrollable
  })));
}
CenterModalNotice.displayName = 'CenterModalNotice';

export { CenterModalNotice as default };
